import { Text } from '@components/rolex-ui/Text'
import { cn } from '@lib/cn'
import { useTranslation } from 'next-i18next'
import { FC } from 'react'

const Benefits: FC = () => {
  const { t } = useTranslation('rolex')

  return (
    <div
      className={cn(
        'mt-[30px] flex flex-col gap-5 border-t-2 border-t-shade-700 pt-[15px]',
        'md:mt-10',
        'lg:flex-row lg:gap-0',
      )}
    >
      <Text variant="fixed14">{t('ksps.delivery')}</Text>
      <Text variant="fixed14" className="lg:mx-2 lg:border-x-2 lg:border-x-shade-600 lg:px-2">
        {t('ksps.return')}
      </Text>
      <Text variant="fixed14">{t('ksps.collect')}</Text>
    </div>
  )
}

export default Benefits
